import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_EventsList,
    postAPI_EventsDisplayOrder
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import events_calendar from '../../../../../assets/event_calender.png';
import "antd/dist/antd.css";
import EventsList from './components/EventsList';
import EventsForm from './components/EventsForm';
function Index({ propertyId, locale, isEvent }) {
    const [eventList, setEventList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [orderBy, setOrderBy] = useState({ column: 'Title', label: 'Title' });
    const [search, setSearch] = useState('');
    const [visible, setVisible] = useState(isEvent);
    useEffect(() => {
        LoadData();
    }, [propertyId, isEvent]);
    const LoadData = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_EventsList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}&orderBy=${orderBy.column}&search=${search}`,
        }).then((res) => {
            var list = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
            setEventList(list);
            setLoading(false);
        });
    }
    const orderOptions = [
        { column: 'Title', label: 'Title' },
        { column: 'Type', label: 'Type' },
        { column: 'Response', label: 'Response' },
        { column: 'Status', label: 'Status' },
    ];
    const toggleModal = () => {
        setVisible(!visible);
    };
    const changeOrderBy = (column) => {
        setOrderBy(orderOptions.find((x) => x.column === column));
    };

    const onSearchKey = (e) => {
        if (e.key === 'Enter') {
            setSearch(e.target.value.toLowerCase());
        }
    };

    if (loading) {
        return <div className="loading" />;
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (fromIndex, toIndex, type, index) => {
        if (toIndex < 0) return;
        if (type === "LIST-ITEM") {
            const categories = reorder(eventList, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({
                    id: item.id,
                    displayOrder: i
                })
            });
            AxiosAPI({
                method: 'post',
                url: `${postAPI_EventsDisplayOrder}`,
                data: { data: data },
            }).then((res) => {
                return setEventList(categories);
            }).catch((err) => {
                console.log('err', err);
            });
        } else return new Error("NOT A VALID LIST");
    };
    return (
        <Fragment>
            <Row className="app-row survey-app">
                <Colxx xxs="12">
                    <div className="mt-2">
                        <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    <IntlMessages id="pages.orderby" />
                                    {orderBy.label}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {orderOptions.map((order, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeOrderBy(order.column)}
                                            >
                                                {order.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search"
                                    onKeyPress={(e) => onSearchKey(e)}
                                />
                            </div>
                            {!loading && (
                                <Fragment>
                                    <div className="text-zero top-right-button-container ml-2">
                                        <Button
                                            color="primary"
                                            size="xs"
                                            outline
                                            className="top-right-button mr-1"
                                            onClick={toggleModal}
                                        >
                                            + Add Event
                                        </Button>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            {!loading ? (
                eventList.length > 0 ?
                    <ReactDragListView
                        nodeSelector=".ant-list.draggable"
                        lineClassName="dragLine"
                        onDragEnd={(fromIndex, toIndex) =>
                            onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                        }
                    >
                        {eventList.map((elem, index) => (
                            <List key={index} className="draggable">
                                <div className="d-flex flex-row mb-3">
                                    <span className="mt-3 draggable"><a href="#"><i className="simple-icon-menu"></i></a></span>
                                    <EventsList
                                        item={elem}
                                        propertyId={propertyId}
                                        toggle={() => toggleModal()}
                                        LoadData={LoadData}
                                        lang={locale}
                                    ></EventsList>
                                </div>
                            </List>
                        ))}
                    </ReactDragListView>
                    : (
                        <Fragment>
                            <div style={{
                                position: 'absolute',
                                left: '40%',
                                padding: "10px"
                            }}>
                                <div>
                                    <img
                                        src={events_calendar}
                                        alt="Events Calendar"
                                        style={{ maxWidth: '400px' }}
                                    />
                                </div>
                                <div style={{
                                    position: "relative",
                                    // bottom: "60px",
                                    padding: "10px", textAlign: "center"
                                }}>
                                    <Button
                                        color="primary"
                                        size="xs"
                                        className="top-right-button mr-1"
                                        onClick={() => toggleModal()}
                                        outline
                                    >
                                        + Add Event
                                    </Button>
                                </div>
                            </div>
                        </Fragment>
                    )
            ) : (
                <div className="loading" />
            )}
            {visible &&
                <EventsForm
                    visible={visible}
                    toggle={() => toggleModal()}
                    propertyId={propertyId}
                    languageCode={locale}
                    LoadData={LoadData}
                ></EventsForm>
            }

        </Fragment>
    )
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, domains } = settings;
    return {
        propertyId,
        locale,
        domains
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));